import { action, makeObservable, observable } from "mobx";

import { EndpointType } from "../../constants/Endpoints";
import { FeatureFlag, UserSettings } from "../../types/iframeMessage";

const defaultUserSettings: UserSettings = {
  model_access_role: "",
  logging_config: {
    api_log_enabled: true,
    playground_log_disabled: false,
  },
};

const defaultFeatureFlag: FeatureFlag = {
  allowDpPremium: false,
};

class EndpointStore {
  endpointType = "" as EndpointType; // TODO : endpointType 정의
  accessToken = "";
  token = "";
  tenantId = "";
  sessionId = "";
  userSettings = defaultUserSettings;
  featureFlag = defaultFeatureFlag;
  isLogin = false;
  setEndpointType(type: EndpointType) {
    this.endpointType = type;
  }
  setAccessToken(accessToken: string) {
    this.accessToken = accessToken;
  }
  setTenantId(tenantId: string) {
    this.tenantId = tenantId;
  }
  setSessionId(sessionId: string) {
    this.sessionId = sessionId;
  }
  setUserSettings(userSettings: UserSettings) {
    this.userSettings = userSettings;
  }
  setFeatureFlag(featureFlag: FeatureFlag) {
    this.featureFlag = featureFlag;
  }
  setIsLogin(isLogin: boolean) {
    this.isLogin = isLogin;
  }
  constructor() {
    makeObservable(this, {
      endpointType: observable,
      setEndpointType: action,
      accessToken: observable,
      setAccessToken: action,
      tenantId: observable,
      setTenantId: action,
      sessionId: observable,
      setSessionId: action,
      userSettings: observable,
      setUserSettings: action,
      isLogin: observable,
      setIsLogin: action,
    });
    this.setEndpointType = this.setEndpointType.bind(this);
    this.setAccessToken = this.setAccessToken.bind(this);
    this.setTenantId = this.setTenantId.bind(this);
    this.setSessionId = this.setSessionId.bind(this);
    this.setUserSettings = this.setUserSettings.bind(this);
    this.setFeatureFlag = this.setFeatureFlag.bind(this);
    this.setIsLogin = this.setIsLogin.bind(this);
  }
}

export const endpointStore = new EndpointStore();
